import React, { useEffect, useState } from "react";
import AddCoach from "../../components/buttons/addCoach";
import CoachList from "./coachList";

export default function CoachMgmt() {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <div className="courseSetUp">
        <div className="topList">
          <h2 className="top-heading">Coach Management</h2>
          <div className="search-inp">
            <button type="submit">Search</button>
            <input
              className="dashboard-search"
              type="search"
              placeholder="Search Coach..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <AddCoach />
        </div>
        {/* Pass searchTerm as a prop */}
        <CoachList search={searchTerm} />
      </div>
    </>
  );
}
